export const ui = {
    promoInput: document.querySelector(
        "#sponsored_party_code"
    ) as HTMLInputElement,
    formInputCode: document.querySelector(
        ".form-input:has(#sponsored_party_code)"
    ) as HTMLParagraphElement,
    formInputError: document.querySelector(
        ".form-input.has-error > ul > li"
    ) as HTMLParagraphElement,
}